export default {
  errors: null,
  prescriptions: [],
  loading: false,
  count: 0,
  totalCount: 0
};
